<template>
    <div class="exchange-offer-list-item" :data-open="showDetail" :disabled="!data.enabled">
        <div class="exchange-offer-list-item-container" @click="showDetail=!showDetail">
            <div class="trade-in-currency currency" :title="data.trade_in_asset_name"><span>{{data.trade_in_asset_name}}</span></div>
            <div class="exchange-offer-info">
                <div class="rate" v-loading="processing">
                    <span v-if="data.price" :title="data.price">{{data.price}}</span>
                    <span v-else>?</span>
                </div>
                <el-progress :percentage="percentage" :format="fund_available" v-if="data"></el-progress>
            </div>
            <div class="trade-out-currency currency" :title="data.trade_out_asset_name"><span>{{data.trade_out_asset_name}}</span></div>
            <div class="my-offer" v-if="myOffer">MY OFFER</div>

        </div>
        <div
            class="exchange-offer-list-item-details"
            v-show="showDetail"
            v-loading="processing_quote"
        >
            <div class="detail">
                <div class="detail-title">Offer UUID</div>
                <div class="detail-value">{{exchange_offer_uuid}}</div>
            </div>
            <!-- <div class="detail">
                <div class="detail-title">Rate</div>
                <div class="detail-value">{{data.rate}}</div>
            </div> -->
            <div class="detail" v-if="isAdmin">
                <div class="detail-title">Listed by</div>
                <div class="detail-value">{{data.display_name}} on {{data.created | formatDate}}</div>
            </div>
            <div class="detail">
                <div class="detail-title">Trade in currency</div>
                <div class="detail-value">{{data.trade_in_asset_name}}</div>
            </div>
            <div class="detail">
                <div class="detail-title">Trade out currency</div>
                <div class="detail-value">{{data.trade_out_asset_name}}</div>
            </div>
            <div class="detail" v-if="myOffer">
                <div class="detail-title">Target currency</div>
                <div class="detail-value">{{data.target_asset_name}}</div>
            </div>
            <div class="detail" v-if="!hasQuoted">
                <div class="detail-title">Minimum trade amount</div>
                <div class="detail-value">{{data.min_trade_amount}} {{data.target_asset_name}}</div>
            </div>
            <div class="detail" v-if="!hasQuoted">
                <div class="detail-title">Maximum trade amount</div>
                <div class="detail-value">{{data.max_trade_amount}} {{data.target_asset_name}}</div>
            </div>
            <div class="detail" v-if="!myOffer">
                <div class="detail-title">Your available balance</div>
                <div class="detail-value">{{availableFunds}} {{data.trade_in_asset_name}}</div>
            </div>
            <div class="detail" v-if="myOffer">
                <div class="detail-title">Margin</div>
                <div class="detail-value">{{margin_percentage}}</div>
            </div>
            <div class="detail" v-if="myOffer">
                <div class="detail-title">Hedge enabled</div>
                <div class="detail-value">
                    <el-switch :value="data.enable_hedge" :active-value="1" :inactive-value="0" disabled></el-switch>
                </div>
            </div>
            <div class="detail" v-if="isDealer && myOffer">
                <div class="detail-title">Last updated</div>
                <div class="detail-value">{{data.updated | formatDate}}</div>
            </div>
            <div class="detail" v-if="hasQuoted">
                <div class="detail-title">Price</div>
                <div class="detail-value">{{quote.price}}</div>
            </div>
            <div class="detail" v-if="hasQuoted">
                <div class="detail-title">Trade in amount</div>
                <div class="detail-value">
                    <span>{{trade_in_amount.toFixed(4)}} {{quote.trade_in_asset_name}}</span>
                    <el-tag
                        effect="dark"
                        type="warning"
                        size="mini"
                    >Price available until {{(timeout/1000).toFixed(1)}}s</el-tag>
                </div>
            </div>
            <div class="detail" v-if="hasQuoted">
                <div class="detail-title">Trade out amount (aprox)</div>
                <div
                    class="detail-value"
                >{{trade_out_amount.toFixed(4)}} {{quote.trade_out_asset_name}}</div>
            </div>
            <div class="hint" v-html="trade_in_desc"></div>

            <div class="balances" v-if="isDealer && myOffer">
                <h4>Withhold Balance</h4>
                <el-card class="asset" v-if="data">
                    <div slot="header" class="clearfix">
                        <span>{{data.trade_in_asset_name}} Withhold Balance</span>
                    </div>
                    <div class="balance">
                        <div class="value">{{data.trade_in_fund_available||0}}</div>
                        <div class="title">Available</div>
                    </div>
                    <div class="balance" v-if="data.trade_in_fund_lock">
                        <div class="value">{{data.trade_in_fund_lock||0}}</div>
                        <div class="title">Loked</div>
                    </div>
                </el-card>
                <el-card class="asset" v-if="data">
                    <div slot="header" class="clearfix">
                        <span>{{data.trade_out_asset_name}} Withhold Balance</span>
                    </div>
                    <div class="balance">
                        <div class="value">{{data.trade_out_fund_available||0}}</div>
                        <div class="title">Available</div>
                    </div>
                    <div class="balance" v-if="data.trade_out_fund_lock">
                        <div class="value">{{data.trade_out_fund_lock||0}}</div>
                        <div class="title">Loked</div>
                    </div>
                </el-card>
            </div>
            <div class="exchanges" v-if="isDealer && myOffer">
                <h4>Exchanges ({{total}})</h4>
                <el-table
                    :data="tableData"
                    style="width: 100%"
                    stripe
                    v-loading="processing"
                    size="mini"
                    row-class-name="deposit-request-item"
                    show-summary
                >
                    <el-table-column label="Created" width="150" fixed>
                        <template slot-scope="scope">{{scope.row.created | formatDate}}</template>
                    </el-table-column>
                    <el-table-column prop="taker_display_name" label="Taker" width="130" fixed></el-table-column>
                    <el-table-column
                        prop="trade_in_amount"
                        :label="`Trade in (${data.trade_in_asset_name})`"
                        width="130"
                    ></el-table-column>
                    <el-table-column
                        prop="fee"
                        :label="`Fee (${data.trade_in_asset_name})`"
                        width="130"
                    ></el-table-column>
                    <el-table-column
                        prop="trade_out_amount"
                        :label="`Trade out (${data.trade_out_asset_name})`"
                        width="130"
                    ></el-table-column>
                    <el-table-column prop="price" label="Price" width="100"></el-table-column>
                </el-table>
                <div class="load-more" @click="loadMore" v-if="tableData.length<total">more...</div>
            </div>
            <div class="quote" v-if="!hasQuoted && data.enabled&&!myOffer">
                <div class="quote-container">
                    <el-form :model="form" ref="form" label-position="top" :rules="rules">
                        <el-form-item :label="trade_in_amount_label" prop="amount">
                            <el-input
                                v-model="form.amount"
                                autocomplete="off"
                                type="number"
                                :min="data.min_trade_amount"
                                :max="data.max_trade_amount"
                                :placeholder="trade_amount_placeholder"
                            >
                                <template slot="append">{{data.target_asset_name}}</template>
                            </el-input>
                        </el-form-item>
                    </el-form>
                    <div class="make-exchange-request-btn" @click="onGetQuoteClick">
                        <i class="el-icon-refresh"></i>Get Quote
                    </div>
                </div>
            </div>
            <el-card class="notice" v-if="notice&&data.enabled&&!myOffer">
                <div slot="header" class="clearfix">
                    <i class="el-icon-warning"></i>
                    <span>{{notice.title}}</span>
                </div>
                <div v-html="notice.description"></div>
            </el-card>
            <div
                class="make-exchange-request-btn"
                v-if="hasQuoted&&!myOffer&&data.enabled"
                @click="onExchangeNowClick"
            >
                <i class="el-icon-money"></i>Exchange Now {{(timeout/1000).toFixed(1)}}s
            </div>
            <div
                class="make-exchange-request-btn cancel"
                @click="onDeleteClick"
                v-if="myOffer&&data.enabled"
            >
                <i class="el-icon-delete"></i>Cancel Exchange Offer
            </div>
        </div>

        <el-dialog
            title="Make an Exchange"
            width="600px"
            :visible="showNewRequest"
            :append-to-body="true"
            :close-on-click-modal="false"
            @close="onNewRequestClose"
        >
            <ExchangeRequestNew
                :exchange_offer_id="data.id"
                :exchange_offer_uuid="exchange_offer_uuid"
                v-if="data&&showNewRequest"
                :onClose="onNewRequestClose"
            />
        </el-dialog>
    </div>
</template>

<script>
// @ is an alias to /src
import { mapActions, mapState } from "vuex";
import Big from "big.js";
import ExchangeRequestNew from "@/components/ExchangeRequestNew";

export default {
    name: "ExchangeOfferListDynamicItem",
    components: {
        ExchangeRequestNew
    },
    props: {
        data: Object,
        onQuote: { type: Function, default: () => {} },
        reload: { type: Function, default: () => {} },
        is_selected: Number
    },
    data() {
        var ctrl = this;
        var validateAmount = (rule, value, callback) => {
            let v = Number(value);
            if (v <= 0) {
                callback(new Error(`Quote amount is required`));
            } else if (v > ctrl.data.max_trade_amount) {
                callback(
                    new Error(
                        `Maximum amount is ${ctrl.data.max_trade_amount} ${ctrl.data.target_asset_name}`
                    )
                );
            } else if (v < ctrl.data.min_trade_amount) {
                callback(
                    new Error(
                        `Minimum amount is ${ctrl.data.min_trade_amount} ${ctrl.data.target_asset_name}`
                    )
                );
            } else {
                callback();
            }
        };
        return {
            balances: [],
            // rate: this.data.rate,
            quote: null,
            exchange_offer_uuid: this.data.uuid,
            processing: false,
            processing_quote: false,
            showDetail: false,
            showNewRequest: false,
            tableData: [],
            total: 0,
            skip: 0,
            form: {
                amount: 0
            },
            timeout: 0,
            timer: null,
            rules: {
                amount: [
                    {
                        required: true,
                        message: "Trade in amount required",
                        trigger: "blur"
                    },
                    {
                        validator: validateAmount,
                        trigger: "blur"
                    }
                ]
            }
        };
    },
    mounted() {
        this.showDetail = this.is_selected == this.data.id;
    },
    watch: {
        showDetail(newShow) {
            if (newShow) {
                this.loadQuote();

                if (this.myOffer || this.isAdmin) {
                    this.loadRequestData();
                } else {
                    this.getBalance();
                }
            }
        }
    },
    computed: {
        ...mapState({
            userInfo: state => state.userInfo,
            currency: state => state.currency,
            currencies: state => {
                return [...state.currency.fiat, ...state.currency.token];
            },
            notices: state => state.notices,
            adminPerms: state => state.adminPerms
        }),
        hasQuoted() {
            if(this.quote && this.quote.exchange_request_id == null) {
                return true;
            }
            return false;
        },
        rate() {
            if (!this.data || !this.data.rate) {
                return "?";
            }
            if (this.offer_type == "SELL") {
                return new Big(1).div(new Big(this.data.rate)).toFixed(4);
            }
            return this.data.rate;
        },
        percentage() {
            if (this.data) {
                return (
                    (this.data.trade_out_fund_available /
                        this.data.trade_out_amount) *
                    100
                );
            }
            return 0;
        },
        trade_in_desc() {
            if (this.quote) {
                return `You will trade in <b>${this.trade_in_amount.toFixed(4
                )} ${
                    this.data.trade_in_asset_name
                }</b><br>You will receive <b>approximate ${this.trade_out_amount.toFixed(
                    4
                )} ${this.data.trade_out_asset_name}</b> as exchange.`;
            }

            if (this.data.trade_in_asset_name == this.data.target_asset_name) {
                return `Every <b>1 ${this.data.target_asset_name}</b> you trade in you will receive <b>approximate ${this.data.price} ${this.data.price_asset_name}</b> as exchange.`;
            }
            return `Every <b>1 ${this.data.target_asset_name}</b> will cost you <b>approximate ${this.data.price} ${this.data.price_asset_name}</b>.`;
        },
        trade_in_amount_label() {
            if (this.data.trade_in_asset_name == this.data.target_asset_name) {
                return `How many ${this.data.target_asset_name} would you like to sell?`;
            } else {
                return `How many ${this.data.target_asset_name} would you like to buy?`;
            }

            // if (this.offer_type == "SELL") {
            //     return `How many ${this.data.trade_out_asset_name} would you like to buy?`;
            // } else {
            //     return `How many ${this.data.trade_in_asset_name} would you like to trade in?`;
            // }
        },
        max_trade_amount() {
            let ctrl = this;
            if (ctrl.data.max_trade_amount) {
                if (ctrl.balances && ctrl.balances.length > 0) {
                    if (
                        ctrl.data.trade_in_asset_name ==
                        ctrl.data.target_asset_name
                    ) {
                        if(ctrl.data.max_trade_amount > ctrl.availableFunds ) {
                            return ctrl.availableFunds;
                        }
                    } else {
                        if ( ctrl.data.max_trade_amount > ctrl.availableFunds / ctrl.data.rate ) {
                            return Number(
                                Big(ctrl.availableFunds).div(
                                    Big(ctrl.data.rate)
                                )
                            );
                        }
                    }
                }
                return ctrl.data.max_trade_amount;
            }
            return 0;
        },
        trade_amount_placeholder() {
            return `${this.data.min_trade_amount} ${this.data.target_asset_name} ~ ${this.max_trade_amount} ${this.data.target_asset_name}`;
        },

        offer_type() {
            if (
                this.currency.token.findIndex(c => {
                    return c.asset_name == this.data.trade_out_asset_name;
                }) >= 0
            ) {
                return "SELL";
            }
            return "BUY";
        },
        trade_in_amount() {
            if (!this.quote) {
                return 0;
            }
            if (this.data.trade_in_asset_name == this.data.target_asset_name) {
                return this.quote.amount;
            } else {
                return this.quote.amount * this.quote.rate;
            }
        },
        trade_out_amount() {
            if (!this.quote) {
                return 0;
            }
            if (this.data.trade_in_asset_name == this.data.target_asset_name) {
                return this.quote.amount / this.quote.rate;
            } else {
                return this.quote.amount;
            }
        },
        notice() {
            return this.notices[`EXCHANGE_${this.data.type}_NOTICE`];
        },
        myOffer() {
            return this.data.authenticate_id == this.userInfo.authenticate_id;
        },
        isDealer() {
            return (
                this.userInfo.perms.findIndex(p => {
                    return p == "DEALER";
                }) >= 0
            );
        },
        isAdmin() {
            if (
                this.adminPerms &&
                this.adminPerms.exchange &&
                this.adminPerms.exchange[0].visibility
            ) {
                return true;
            }
            return false;
        },
        availableFunds() {
            let ctrl = this;
            if (ctrl.balances && ctrl.balances.length > 0) {
                let idx = ctrl.balances.findIndex(b => {
                    return b.asset_name == ctrl.data.trade_in_asset_name;
                });
                if (idx >= 0) {
                    // return `${ctrl.balances[idx].fund_available.toFixed(4)} ${ctrl.balances[idx].asset_name} available`
                    return ctrl.balances[idx].fund_available;
                }
            }
            return 0;
        },
        margin_percentage() {
            if (this.data && this.data.margin) {
                return `${new Big(this.data.margin).times(100)}%`;
            }
            return `0%`;
        }
    },
    methods: {
        ...mapActions(["request", "getError"]),
        fund_available() {
            return `${this.data.trade_out_fund_available} ${this.data.trade_out_asset_name} For sale (Total ${this.data.trade_out_amount} ${this.data.trade_out_asset_name})`;
        },
        onNewRequestClose(reload = false) {
            this.showNewRequest = false;
            if (reload) {
                this.reload();
            }
        },
        loadQuote() {
            let ctrl = this;
            if (ctrl.data && ctrl.data.id) {
                ctrl.processing_quote = true;
                ctrl.request({
                    method: "GET",
                    endpoint: `exchange/${this.data.id}/quote`
                })
                    .then(({ data = {} }) => {
                        if (data.length > 0) {
                            ctrl.quote = data[0];
                            ctrl.timeout =
                                new Date(data[0].created).getTime() +
                                10001 -
                                Date.now();
                            setTimeout(
                                uuid => {
                                    if (uuid == ctrl.quote.uuid) {
                                        ctrl.quote = null;
                                        ctrl.timeout = 0;
                                        clearInterval(ctrl.timer);
                                    }
                                },
                                ctrl.timeout,
                                data[0].uuid
                            );
                            ctrl.timer = setInterval(() => {
                                ctrl.timeout -= 200;
                            }, 200);
                        } else {
                            ctrl.quote = null;
                        }
                    })
                    .catch(err => {
                        ctrl.getError({
                            err
                        }).then(ctrl.$notify);
                    })
                    .finally(() => {
                        setTimeout(() => {
                            ctrl.processing_quote = false;
                        }, 500);
                    });
            }
        },
        onGetQuoteClick() {
            let ctrl = this;
            ctrl.$refs.form.validate(valid => {
                if (valid) {
                    
                    ctrl.processing = true;
                    ctrl.request({
                        method: "POST",
                        endpoint: `exchange/${this.data.id}/quote`,
                        data: {
                            amount: this.form.amount
                        }
                    })
                        .then(({ data }) => {
                            this.onQuote(data.exchange_offer_id);
                        })
                        .catch(err => {
                            ctrl.getError({
                                err,
                                title: "EXCHANGE_OFFER_QUOTE_ERROR",
                                message: "Quote exchange offer failed"
                            }).then(ctrl.$notify);
                        })
                        .finally(() => {
                            setTimeout(() => {
                                ctrl.processing = false;
                            }, 500);
                        });
                } else {
                    return false;
                }
            });
        },
        onDeleteClick() {
            let ctrl = this;

            ctrl.$confirm(`Would like to stop listing this offer?`, {
                title: "Confirm to proceed",
                confirmButtonText: `Confirm`,
                cancelButtonText: "Cancel",
                type: "warning"
            })
                .then(() => {
                    ctrl.processing = true;
                    ctrl.request({
                        method: "DELETE",
                        endpoint: `exchange/${this.data.id}`
                    })
                        .then(() => {
                            ctrl.$message({
                                message: `Exchange offer ${this.data.exchange_offer_uuid} has been been cancelled`,
                                type: "success"
                            });
                        })
                        .catch(err => {
                            ctrl.getError({
                                err,
                                title: "EXCHANGE_OFFER_QUOTE_ERROR",
                                message: "Cancel exchange offer failed"
                            }).then(ctrl.$notify);
                        })
                        .finally(() => {
                            setTimeout(() => {
                                ctrl.processing = false;
                                ctrl.reload();
                            }, 500);
                        });
                })
                .catch(() => {});
        },
        onExchangeNowClick() {
            let ctrl = this;
            ctrl.$confirm(
                `Would like to proceed to trade in 
                    ${ctrl.trade_in_amount.toFixed(8)} ${
                    ctrl.quote.trade_in_asset_name
                } 
                    to get approximate 
                    ${ctrl.trade_out_amount.toFixed(8)} ${
                    ctrl.quote.trade_out_asset_name
                }?`,
                {
                    title: "Confirm to proceed",
                    confirmButtonText: `Confirm`,
                    cancelButtonText: "Cancel",
                    type: "warning"
                }
            )
                .then(() => {
                    if (ctrl.quote) {
                        ctrl.processing = true;
                        ctrl.request({
                            method: "POST",
                            endpoint: `exchange/${ctrl.quote.exchange_offer_id}/request`,
                            data: {
                                exchange_offer_uuid:
                                    ctrl.quote.exchange_offer_uuid,
                                amount: ctrl.quote.amount
                            }
                        })
                            .then(() => {
                                ctrl.$message({
                                    message: "Exchange has been made",
                                    type: "success"
                                });
                            })
                            .catch(err => {
                                ctrl.getError({
                                    err,
                                    title: "EXCHANGE_OFFER_QUOTE_ERROR",
                                    message: "Quote exchange offer failed"
                                }).then(ctrl.$notify);
                            })
                            .finally(() => {
                                ctrl.processing = false;
                                ctrl.reload();
                            });
                    } else {
                        ctrl.$notify({
                            title: "EXCHANGE_OFFER_QUOTE_ERROR",
                            message: "Quote has expired"
                        });
                    }
                })
                .catch(() => {});
        },
        loadRequestData({ skip = 0, limit = 100, id = null } = {}) {
            if (!this.myOffer && !this.isAdmin) {
                return;
            }
            let ctrl = this;
            ctrl.processing = true;
            let endpoint = `exchange/requests`;
            let params = {
                limit,
                skip
            };
            if (ctrl.data.exchange_offer_id) {
                params.where = `exchange_offer_id=${ctrl.data.exchange_offer_id}`;
            }
            ctrl.request({
                method: "GET",
                endpoint,
                params
            })
                .then(({ data = {} }) => {
                    if (skip == 0) {
                        ctrl.tableData = [];
                    }
                    ctrl.total = data.total;
                    ctrl.skip += data.results.length;
                    ctrl.tableData = [...ctrl.tableData, ...data.results];
                    if (id) {
                        for (let result of data.results) {
                            if (result.id == id) {
                                ctrl.selectedData = id;
                            }
                        }
                    }
                })
                .catch(err => {
                    ctrl.getError({
                        err
                    }).then(ctrl.$notify);
                })
                .finally(() => {
                    setTimeout(() => {
                        ctrl.processing = false;
                    }, 500);
                });
        },
        loadMore() {
            this.loadRequestData({ skip: this.skip });
        },
        getBalance() {
            let ctrl = this;
            ctrl.processing = true;
            ctrl.request({
                method: "GET",
                endpoint: "my/balance/my"
            })
                .then(({ data }) => {
                    this.balances = data.assets;
                })
                .catch(err => {
                    let title = "Get my balance failed";
                    let message =
                        err.message || err.statusText || "Unknown Error";
                    if (err.data) {
                        (title = err.data.name), (message = err.data.message);
                    }
                    this.$notify({
                        title,
                        message
                    });
                })
                .finally(() => {
                    ctrl.processing = false;
                });
        }
    }
};
</script>
<style scoped>
.exchange-offer-list-item,
.exchange-offer-list-item * {
    box-sizing: border-box;
    -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
    transition: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
}
.trade-in-currencies {
    background-color: rgba(0, 0, 0, 0.2);
}

.exchange-offer-list-content {
    flex: 1;
    flex-direction: column;
}

.exchange-offer-list-item {
    background-color: rgba(0, 0, 0, 0.08);
    border-bottom: 1px solid rgba(0, 0, 0, 0.5);
    position: relative;
    width: 100%;
}

.exchange-offer-list-item[disabled] {
    opacity: 0.35;
}

.exchange-offer-list-item[disabled]::after {
    content: "Completed";
    position: absolute;
    content: "Closed";
    position: absolute;
    background-color: #177CB0;
    color: #FFF;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    font-size: 12px;
    padding: 4px 8px;
    border-radius: 5px;
    opacity: 0.8;
    top: 3px;
    right: 80px;
    transform: rotate(8deg);
    transform-origin: top left;
}

.exchange-offer-list-item:hover {
    background-color: #eee;
}

.exchange-offer-list-item-container {
    display: flex;
    justify-content: space-between;
    line-height: 60px;
    cursor: pointer;
    color: #444;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}
.exchange-offer-list-item-container:hover {
    background-color: rgba(0, 0, 0, 0.2);
}

.exchange-offer-list-item[data-open="true"] {
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.4);
    background-color: #eee;
    margin: 8px;
    margin-top: 24px;
    padding-top: 50px;
    border-radius: 5px;
    border-bottom: none;
    width: calc(100% - 16px);
}
.exchange-offer-list-item[disabled][data-open="true"] {
    opacity: 0.9;
}
.exchange-offer-list-item[disabled][data-open="true"]::after {
    top: -13px;
}

.exchange-offer-list-item[data-open="true"]
    .exchange-offer-list-item-container {
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.2);
    background-color: #eee;
    margin: 0 8px;
    border-radius: 5px;
    position: absolute;
    width: calc(100% - 16px);
    top: -16px;
}

.exchange-offer-list-item[data-open="true"]
    .exchange-offer-list-item-container:hover {
    background-color: #eee;
}

.currency {
    padding: 0 8px;
    text-align: center;
    width: 100px;
    background-color: #1176a9;
    color: #FFF;
    display: flex;
    align-content: center;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.currency > span {
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.exchange-offer-info {
    padding: 0;
    display: flex;
    align-content: center;
    align-items: center;
    background-color: rgba(255, 255, 255, 0.05);
    flex: 1;
}

.rate {
    padding: 0 8px;
    width: 140px;
    text-align: center;
    background-color:#1a84ba;
    color: #FFF;
    position: relative;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.exchange-offer-list-item-details {
    background-color: rgba(0, 0, 0, 0.4);
    line-height: 30px;
}
.exchange-offer-list-item[data-open="true"] .exchange-offer-list-item-details {
    background-color: transparent;
    color: #000;
    overflow: hidden;
    border-radius: 0 0 4px 4px;
}
.detail-title {
    padding: 0 16px;
}

.detail-title {
    background-color: rgba(0, 0, 0, 0.2);
    width: 220px;
}

.detail {
    display: flex;
    border-top: 1px solid rgb(250, 250, 250);
    font-size: 14px;
}

.detail-value {
    padding: 0 16px;
}
.make-exchange-request-btn {
    text-align: center;
    line-height: 30px;
    cursor: pointer;
    width: 100%;
    border: none;
    font-size: 14px;
    color: #FFF;
    background-color: rgba(0, 0, 0, 0.3);
    line-height: 50px;
    font-size: 16px;
}

.make-exchange-request-btn:hover {
    background-color: #114f70;
}
.make-exchange-request-btn:active {
    background-color:  #0f4c6d;
}
.exchange-offer-list-item[data-open="true"] .make-exchange-request-btn {
    background-color:#12567a;
    margin-top: 8px;
    box-shadow: 0 1px 12px 0 rgba(0, 0, 0, 0.2);
}
.exchange-offer-list-item[data-open="true"] .make-exchange-request-btn:hover {
    background-color: #114f70;
}
.exchange-offer-list-item[data-open="true"] .make-exchange-request-btn:active {
    background-color: #0f4c6d;
}
.make-exchange-request-btn i {
    padding-right: 4px;
}
.make-exchange-request-btn.cancel {
    color: #fff;
}
.quote {
    padding: 8px;
    margin-top: 8px;
}
.quote-container {
    box-shadow: 0 1px 12px 0 rgba(0, 0, 0, 0.2);
}
.quote-container-title {
    padding: 8px 16px 0px;
    line-height: 30px;
}
.quote-container .el-form {
    padding: 8px 16px;
}
.balances {
    display: flex;
    flex-direction: row;
    padding: 8px;
    flex-wrap: wrap;

    background-color: rgba(0, 0, 0, 0.1);
    margin-top: 8px;
    border-top: 1px solid rgba(0, 0, 0, 0.1);
}
.exchanges {
    display: flex;
    flex-direction: column;
    background-color: rgba(0, 0, 0, 0.1);
    border-top: 1px solid rgba(0, 0, 0, 0.1);
    margin-top: 8px;
}
.balances h4,
.exchanges h4 {
    width: 100%;
    text-align: center;
    margin: 0px;
    line-height: 40px;
    padding-bottom: 8px;
}
.balances .asset {
    flex: 1;
    max-width: 50%;
}
.balances .asset + .asset {
    margin-left: 8px;
}
.balances .asset .title {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.65);
    border-top: 1px solid rgba(0, 0, 0, 0.2);
    padding: 0 8px;
}
.balances .asset .value {
    font-size: 18px;
    color: rgba(0, 0, 0, 0.85);
    padding: 0 8px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
}
.hint {
    padding: 16px;
    background-color: #12567a;
    border-bottom: 2px solid rgba(0, 0, 0, 0.2);
    line-height: normal;
    color: rgba(255, 255, 255, 0.85);
    margin-top: 8px;
}
</style>
<style>
.el-progress {
    padding: 0 8px;
}
.el-progress-bar {
    padding-right: 0px;
    display: flex;
    flex-direction: column;
}

.el-progress__text {
    text-align: center;
    margin-left: 0px;
    font-size: 12.5px !important;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    color: #444;
    padding-top: 8px;
}

.el-progress {
    flex: 1;
}
.exchanges .el-table .cell {
    white-space: nowrap;
}
.my-offer {
    position: absolute;
    color: #FFF;
    background-color: #195675;
    border-top: 1px solid rgba(255,255,255,0.4);
    border-bottom: 1px solid rgba(0,0,0,0.1);
    width: 86px;
    text-align: center;
    height: 18px;
    line-height: 18px;
    font-size: 11px;
    left: 8px;
    top: -1px;
}
</style>